import { ISelectable } from 'starbase-launcher';

export interface ITypeaheadResults {
  /**Sum of all matches returned from server */
  totalMatches: number;
  /**Sum of all errors returned by server */
  totalErrors: number;
  /**Data for the matches returned, including the matches (as strings) themselves */
  matches: [{ 'tableName': string; 'hits': { [key: string]: string[] }; 'matchCount': number }];
  /**User's search term */
  userInput: string;
  /**Messages returned from the server upon failures */
  errorMessages: string[];
}

export class TypeaheadResults implements ITypeaheadResults, ISelectable {
  public totalMatches: number;
  public totalErrors: number;
  public matches: [{
      tableName: string;
      hits: {
        [key: string]: string[];
      };
      matchCount: number;
      selected: boolean;
  }] = [{
        tableName: '',
        hits: {},
        matchCount: 0,
        selected: false
      }];
  public userInput: string;
  public errorMessages: string[];
  public selected: boolean; // pseudo-property

    constructor(term: string, entities: string[]) {
        this.totalErrors = 0;
        this.totalMatches = 0;
        entities.forEach(e => {
            this.matches.push({ tableName: e, hits: {}, matchCount: 0 , selected: false});
        });
        this.userInput = term;
        this.errorMessages = [];
    }
}
